import React from 'react';
import styles from './style.module.scss';
import type { CommercialPropertyClusterItem } from '@zoocasa/go-search';
import Paper from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Card, CardActionArea, CardMedia, Divider, Grid, SxProps } from '@mui/material';
import { buildClassName } from 'utils/build-class-name';
import { getCommercialTitle } from '../ListingCard';
import imageLoader from 'components/listing-image/image-loader';

export type CommercialCalloutProps = {
  count: number;
  listings: CommercialPropertyClusterItem[];
  onClose: () => void;
  containerSx?: SxProps;
};

export default function CommercialCallout({ count, listings, onClose, containerSx = { borderRadius: '20px' }}: CommercialCalloutProps) {
  return (
    <Paper role="presentation" elevation={1} sx={{ ...containerSx }}>
      <div className={styles['callout-header']}>
        <span>{count}</span>&nbsp;selected
        <IconButton aria-label="close" onClick={onClose} className={styles['close']}>
          <CloseIcon fontSize='small' />
        </IconButton>
      </div>
      <div className={styles['callout-body']}>
        <div>
          {listings.map(item => {
            const meta = [
              item.priceLabel,
              item.buildingSize,
              item.propertySubType,
            ];

            let imageSrc = '/next/assets/images/exp-commercial/commercial-no-listing-image.webp';
            if (item.thumbnailImage) {
              imageSrc = imageLoader({ src: item.thumbnailImage, isListingCardImage: true });
            }
            return (
              <Card key={item.slug} className={styles.card} sx={{ borderRadius: '12px', boxShadow: '0px 1px 10px 0px rgba(0, 0, 0, 0.12)' }}>
                <CardActionArea component='a' href={`/listings/${item.slug}`} sx={{ display: 'flex', height: 'inherit', textDecoration: 'none !important' }}>
                  <Grid container alignItems='stretch' sx={{ height: 'inherit' }}>
                    <Grid item xs={4} sx={{ height: 'inherit', position: 'relative', overflow: 'hidden' }}>
                      <CardMedia
                        component="img"
                        image={imageSrc}
                        alt={item.name || ''}
                        sx={{ height: 'inherit' }}
                        className={buildClassName(styles.image, !item.thumbnailImage && styles['no-image'])}
                      />
                    </Grid>
                    <Grid item xs={8} className={styles.right}>
                      <h4 className={styles.title}>{item.name ?? item.unparsedAddress}</h4>
                      <address className={styles.address}>{getCommercialTitle({ name: item.name, unparsedAddress: item.unparsedAddress, city: item.city, stateOrProvince: item.stateOrProvince })}</address>
                      <div className={styles.meta}>
                        {meta.filter(Boolean).map((item, index, array) => (
                          <React.Fragment key={item}>
                            {item}
                            {index < array.length - 1 && <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(206, 207, 211, 1)' }} />}
                          </React.Fragment>
                        ))}
                      </div>
                    </Grid>
                  </Grid>
                </CardActionArea>
              </Card>
            );
          })}
        </div>
      </div>
    </Paper>
  );
}


